import { render } from "./ReservasFinSemana.vue?vue&type=template&id=595c1368&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"comensales\":\"data\"}"
import script from "./ReservasFinSemana.vue?vue&type=script&lang=js"
export * from "./ReservasFinSemana.vue?vue&type=script&lang=js"
script.render = render

export default script